(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["verqelle-heated-blanket-cozy-hero"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.verqelle-heated-detail__video-box').forEach((box) => {
    const video = box.querySelector('.verqelle-heated-detail__video');
    const button = box.querySelector('.verqelle-heated-detail__video-play');
    if (!video || !button) return;

    const syncButton = () => {
      button.classList.toggle('is-hidden', !video.paused);
    };

    button.addEventListener('click', () => {
      video.play().catch(() => {});
    });

    video.addEventListener('play', syncButton);
    video.addEventListener('pause', syncButton);
    syncButton();
  });
  } catch(e) { console.error(e); }
})();

})();
